/**
 * @name ShopOperatorsController
 * @description Controller for shop operators
 * @param {service} Operators The operators service
 * @param {service} Session The session service
 * @param {service} Association The associations service
 * @param {service} $uibModal The $uibModal service from UI Bootstrap
 * @param {service} AlertMessages The alert messages service
 * @param {service} RESPONSE_MESSAGES The response messages constant
 */
function ShopOperatorsController(
  Operators,
  Session,
  Association,
  $uibModal,
  AlertMessages,
  RESPONSE_MESSAGES
) {
  let vm = this;
  vm.$onInit = function() {
    vm.cancelInvite = cancelInvite;
    vm.updateOperatorAssociation = updateOperatorAssociation;
    vm.expireOperatorAssociation = expireOperatorAssociation;
    vm.shop = Session.activeState.association.shop;
    vm.session = Session;
    getOperators(vm.shop.id);
  };

  /**
   * @name getOperators
   * @description Get shop operators
   * @param {number} shopId The ID of the shop
   */
  function getOperators(shopId) {
    Operators.getAllForShop(shopId).then(function(operators) {
      vm.operators = operators;
    });
  }

  /**
   * @name cancelInvite
   * @description Function to cancel the invite of a collector
   * @param {object} operator The collector to cancel
   */
  function cancelInvite(operator) {
    let modalInstance = $uibModal.open({
      template: require('./cancel-invite-modal.template.html'),
      animation: true,
      controller: 'CancelInviteModalController',
      bindToController: true,
      controllerAs: '$ctrl',
      resolve: {
        operator: function() {
          return operator;
        }
      }
    });
    modalInstance.result.then(
      function() {
        getOperators(vm.shop.id);
      },
      function() {
        AlertMessages.add({
          msg: RESPONSE_MESSAGES.closedWithoutSaving,
          type: 'warning'
        });
      }
    );
  }

  /**
   * @name expireOperatorAssociation
   * @description Function to change association status to expired
   * @param {object} operator The collector to cancel
   */
  function expireOperatorAssociation(operator) {
    let modalInstance = $uibModal.open({
      template: require('./expire/expire-operator-modal.template.html'),
      animation: true,
      controller: 'ExpireOperatorModalController',
      bindToController: true,
      controllerAs: '$ctrl',
      resolve: {
        operator: function() {
          return operator;
        }
      }
    });
    modalInstance.result.then(
      function() {
        getOperators(vm.shop.id);
      },
      function() {
        AlertMessages.add({
          msg: RESPONSE_MESSAGES.closedWithoutSaving,
          type: 'warning'
        });
      }
    );
  }

  /**
   * @name updateOperatorAssociation
   * @description Function to change association status to expired
   * @param {object} operator The collector to cancel
   */
  function updateOperatorAssociation(operator) {
    let modalInstance = $uibModal.open({
      template: require('./update/update-operator-modal.template.html'),
      animation: true,
      controller: 'UpdateOperatorModalController',
      bindToController: true,
      controllerAs: '$ctrl',
      resolve: {
        operator: function() {
          return operator;
        }
      }
    });
    modalInstance.result.then(
      function() {
        getOperators(vm.shop.id);
      },
      function() {
        AlertMessages.add({
          msg: RESPONSE_MESSAGES.closedWithoutSaving,
          type: 'warning'
        });
      }
    );
  }
}

angular
  .module('inkfinder')
  .controller('ShopOperatorsController', ShopOperatorsController);



// WEBPACK FOOTER //
// ./components/shop/operators/shop-operators.controller.js